import { Routes } from '@angular/router';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { permissaoGuard } from './core/guards/permissao.guard';
import { PERMISSOES } from './core/constants/permissoes.constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: '/rastreio',
    pathMatch: 'full',
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'centros-de-custo',
        canActivate: [permissaoGuard([PERMISSOES.CENTROS_CUSTO.VISUALIZAR])],
        loadComponent: () =>
          import('./pages/centro-de-custo/centro-de-custo.component').then(
            (m) => m.CentroDeCustoComponent
          ),
      },
      {
        path: 'remessa',
        canActivate: [permissaoGuard([PERMISSOES.REMESSAS.VISUALIZAR])],
        loadComponent: () =>
          import('./pages/remessa/lista-remessa.component').then(
            (m) => m.ListaRemessaComponent
          ),
      },
      {
        path: 'remessa/novo',
        canActivate: [permissaoGuard([PERMISSOES.REMESSAS.CRIAR])],
        loadComponent: () =>
          import(
            './pages/remessa/remessa-create-modal/remessa-create-modal.component'
          ).then((m) => m.RemessaCreateModalComponent),
      },
      {
        path: 'remessa/:id/detalhes',
        canActivate: [permissaoGuard([PERMISSOES.REMESSAS.VISUALIZAR])],
        loadComponent: () =>
          import(
            './pages/remessa/detalhes-remessa/detalhes-remessa.component'
          ).then((m) => m.DetalhesRemessaComponent),
      },
      {
        path: 'objetos',
        canActivate: [permissaoGuard([PERMISSOES.OBJETOS.VISUALIZAR])],
        loadComponent: () =>
          import('./pages/objeto/lista-objeto.component').then(
            (m) => m.ListaObjetoComponent
          ),
      },
      {
        path: 'selecao-servico',
        canActivate: [permissaoGuard([PERMISSOES.SERVICOS.VISUALIZAR])],
        loadComponent: () =>
          import(
            './pages/emitir/selecao-servico/selecao-servico.component'
          ).then((m) => m.SelecaoServicoComponent),
      },
      {
        path: 'emitir/:servicoId/vinculo-etiqueta',
        canActivate: [permissaoGuard([PERMISSOES.OBJETOS.EMITIR])],
        loadComponent: () =>
          import(
            './pages/emitir/vinculo-etiqueta/vinculo-etiqueta.component'
          ).then((m) => m.VinculoEtiquetaComponent),
      },
      {
        path: 'emitir/:servicoId/vinculo-servico',
        canActivate: [permissaoGuard([PERMISSOES.OBJETOS.EMITIR])],
        loadComponent: () =>
          import(
            './pages/emitir/vinculo-servico/vinculo-servico.component'
          ).then((m) => m.VinculoServicoComponent),
      },
      {
        path: 'postar',
        canActivate: [permissaoGuard([PERMISSOES.OBJETOS.POSTAR])],
        loadComponent: () =>
          import(
            './pages/postar/postar.component'
          ).then((m) => m.PostarComponent),
      },
      {
        path: 'rastreio',
        canActivate: [
          permissaoGuard([PERMISSOES.RASTREIOS.BUSCAR]),
        ],
        loadComponent: () =>
          import('./pages/rastreio/rastreio.component').then(
            (m) => m.RastreioComponent
          ),
      },
      {
        path: 'faturas',
        canActivate: [permissaoGuard([PERMISSOES.FATURAS.VISUALIZAR])],
        loadComponent: () =>
          import('./pages/fatura/lista-fatura.component').then(
            (m) => m.ListaFaturaComponent
          ),
      },
      {
        path: 'faturas/:id/detalhes',
        canActivate: [permissaoGuard([PERMISSOES.FATURAS.VISUALIZAR])],
        loadComponent: () =>
          import(
            './pages/fatura/detalhes-fatura/detalhes-fatura.component'
          ).then((m) => m.DetalhesFaturaComponent),
      },
      {
        path: 'acesso-negado',
        loadComponent: () =>
          import('./shared/components/design-system/error-page.component').then(
            (m) => m.ErrorPageComponent
          ),
        data: {
          type: '403',
          title: 'Acesso Negado',
          description: 'Você não tem as permissões necessárias para acessar este recurso.',
        },
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./shared/components/design-system/error-page.component').then(
        (m) => m.ErrorPageComponent
      ),
    data: {
      type: '404',
      title: 'Página não encontrada',
      description: 'O caminho que você está tentando acessar não existe ou foi movido.',
    },
  },
];